import { useEffect, useState } from "react";
import ChemicalProducts from "../../assets/Images/chemical_products.svg";
import AboutMarketplace from "../../assets/Images/about_marketplace.svg";
import Supporters from "./Supporters.tsx";
import styles from "./startpage.module.css";
import { fetchFilters } from "../../Api/Services/Alternative.ts";
import { AlternativeFilters } from "../../Models/AlternativeModel.ts";
import { Link } from "react-router-dom";
import Searchbar from "../../components/Searchbar/Searchbar.tsx";

export default function StartPage() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [filters, setFilters] = useState<AlternativeFilters>({
    alternativeLevels: [],
    alternativeToCategories: [],
    certificationsCategories: [],
    sectorCategories: [],
    useCategories: [],
  });

  const handleButtonClick = (index: number) => {
    setActiveIndex(index);
  };

  useEffect(() => {
    const getFilters = async () => {
      try {
        const data = await fetchFilters();
        setFilters(data);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };

    getFilters();
  }, []);

  return (
    <div className={styles.startpage}>
      <div className={styles.start_content}>
        <div className={styles.hero}>
          <h1>Find safer alternatives to hazardous chemicals</h1>
          <p>
            Marketplace gathers all green chemistry innovations in one place,
            making it easier for companies to choose safer solutions. Search
            advertisements for safer alternatives and connect with suppliers.
          </p>
        </div>
        <div className={styles.category_container}>
          <h5>Discover alternatives by category</h5>
          <div className={styles.category_group_container}>
            <button
              className={activeIndex === 0 ? styles.active : ""}
              onClick={() => handleButtonClick(0)}
            >
              Alternative to
            </button>
            <button
              className={activeIndex === 1 ? styles.active : ""}
              onClick={() => handleButtonClick(1)}
            >
              Sector
            </button>
            <button
              className={activeIndex === 2 ? styles.active : ""}
              onClick={() => handleButtonClick(2)}
            >
              Use
            </button>
          </div>
          <div className={styles.category_button_container}>
            {activeIndex === 0 &&
              filters.alternativeToCategories.map((category) => (
                <Link
                  key={"Alternative_to_category_" + category.id}
                  className={styles.startpage_category_button}
                  to="/search"
                  state={{ alternativeTo: category.id }}
                >
                  {category.name}
                </Link>
              ))}
            {activeIndex === 1 &&
              filters.sectorCategories.map((category) => (
                <Link
                  key={"Sector_category_" + category.id}
                  className={styles.startpage_category_button}
                  to="/search"
                  state={{ sectorCategory: category.id }}
                >
                  {category.name}
                </Link>
              ))}
            {activeIndex === 2 &&
              filters.useCategories.map((category) => (
                <Link
                  key={"Use_category_" + category.id}
                  className={styles.startpage_category_button}
                  to="/search"
                  state={{ useCategory: category.id }}
                >
                  {category.name}
                </Link>
              ))}
          </div>
          <div className={styles.desktop_search}>
            <h5>Or search directly in the marketplace</h5>
            <Searchbar placeholder="Search the marketplace for eg. supplier, function, sector, chemical etc..." />
          </div>
          <div className={styles.mobile_search}>
            <h5>Or search directly in the marketplace</h5>
            <p>
              Search the marketplace for eg. supplier, function, sector,
              chemical etc...{" "}
            </p>
            <Searchbar placeholder="Search the marketplace" hideArrow={true} mobile={true}>
              <button className="button button_black">Search</button>
            </Searchbar>
          </div>
        </div>
      </div>
      <div className={styles.advertise_container}>
        <img
          src={ChemicalProducts}
          alt="chemical products"
          aria-hidden="true"
        ></img>
        <div>
          <span>Advertise your alternative</span>
          <h4>Are you a supplier offering alternatives?</h4>
          <p>
            Boost your digital presence by advertising your safer solutions
            effortlessly through easy-to-upload advertisements and reach new
            customers worldwide with a single global tool.
          </p>
          <Link to="/advertise-your-alternative" className='button button_white'>Become a supplier</Link>
        </div>
      </div>

      <div className={styles.hr}>
        <span>What is marketplace?</span>
      </div>

            <div className={styles.what_is_container}>
                <div>
                    <h2>Connecting buyers and suppliers of safer alternatives to harmful chemicals</h2>
                </div>
                <div>
                    <p>ChemSec’s Marketplace is a global business-to-business platform where companies can explore — and solution providers can advertise — safer alternatives to hazardous chemicals. It is the first step towards replacing chemicals of concern in products and processes.</p>
                    <p><a href="/search">Search the database</a> and filter for chemical function, relevant industry or a specific hazardous chemical that you are looking to replace.</p>
                </div>
                <div className={styles.content_container}>
                    <span>For Buyers</span>
                    <h4>Discover and buy safer alternatives</h4>
                    <p>Get access to a global platform offering verified safer alternatives to hazardous chemicals, complete with industry-specific search and filter functions, allowing you to connect directly with suppliers on the website.</p>
                    <Link to="/search" className='button button_black'>Discover alternatives</Link>
                </div>

        <div className={styles.content_container}>
          <span>For Suppliers</span>
          <h4>Advertise and sell your safer alternative</h4>
          <p>
            Boost your digital presence by advertising your safer solutions
            effortlessly through easy-to-upload advertisements and reach new
            customers worldwide with a single global tool.
          </p>
          <Link to="/advertise-your-alternative" className='button button_black'>Become a supplier</Link>
        </div>
      </div>

      <div className={styles.hr}>
        <span>About Marketplace (who is behind it)</span>
      </div>

      <div className={styles.about_marketplace}>
        <img src={AboutMarketplace} alt="ChemSec logotype" />
        <div>
          <h2>
          An online platform initiated by ChemSec
          </h2>
          <p>
            Marketplace was initiated by the International Chemical Secretariat — <a href="https://chemsec.org/">ChemSec</a> — a non-profit organisation working towards a planet beyond chemical pollution.
          </p>
          <p>
            At ChemSec, we strive to bridge the gap between decision-makers, industry, institutional investors, NGOs, and scientists. We advocate for progressive chemicals legislation and sustainable corporate chemicals management, and offer guidance to companies committed to changing the way they work with chemicals.
          </p>
          <p>
          To help companies achieve their sustainability goals, we have developed a host of online tools showing how they can reduce the use of hazardous chemicals in their products and supply chains. Used by tens of thousands of professionals around the world, these tools are recognised by many of the world’s biggest companies, the UN, the EU, the European Chemicals Agency (ECHA), environmental organisations and other national and international institutions and research centres.
          </p>
          <a href="https://chemsec.org/" className="button button_black">
            Learn more about Chemsec
          </a>
        </div>
      </div>

      <div className={styles.hr}>
        <span>Marketplace supporters </span>
      </div>

      <div className={styles.supporters_container}>
        <h2>We support Chemsec Marketplace</h2>
        <Supporters />
      </div>
    </div>
  );
}
